import { useState, useEffect } from 'react';

const COOKIE_CONSENT_KEY = 'ghq_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(COOKIE_CONSENT_KEY)) setVisible(true);
    } catch { /* blocked storage */ }
  }, []);

  const accept = () => {
    try { localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted'); } catch { /* noop */ }
    setVisible(false);
  };

  const decline = () => {
    try { localStorage.setItem(COOKIE_CONSENT_KEY, 'declined'); } catch { /* noop */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4">
      <div className="max-w-2xl mx-auto rounded-2xl border border-border bg-surface/95 backdrop-blur-xl shadow-2xl p-5 sm:p-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-ink mb-1">We use cookies</p>
            <p className="text-xs text-ink-muted leading-relaxed">
              We use essential cookies to keep the dashboard running and analytics cookies to improve your experience.{' '}
              <a href="https://www.gatheredhq.com/legal/cookies" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:underline">Cookie Policy</a>
            </p>
          </div>
          <div className="flex items-center gap-2.5 shrink-0">
            <button
              onClick={decline}
              className="h-9 px-4 rounded-lg text-xs font-bold text-ink-muted border border-border hover:bg-surface-muted transition-colors"
            >
              Decline
            </button>
            <button
              onClick={accept}
              className="h-9 px-5 rounded-lg text-xs font-bold btn-gradient"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
